import BlazeSlider from "blaze-slider";
import "blaze-slider/dist/blaze.css";

const fn = {
    init: () => {

        document.querySelectorAll('.blaze-slider').forEach(el => {

            new BlazeSlider(el, {
                all: {
                    slidesToScroll: 1,
                    slidesToShow: 3,
                    enableAutoplay: true
                },
                "(max-width: 1024px)": {
                    slidesToScroll: 2,
                    slidesToShow: 2,
                },
                "(max-width: 768px)": {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                }
            })

            if (el.classList.contains('white-buttons')) {
                el.querySelectorAll('.blaze-pagination').forEach(page => {
                    let buttons = page.querySelectorAll('button')
                    if (buttons.length > 0) {
                        var lastchild = buttons[buttons.length-1];
                        lastchild.setAttribute('data-count', lastchild.innerHTML + ' /')
                    }
                })
            }
        })

        document.querySelectorAll('.blaze-slider-single').forEach(el => {

            new BlazeSlider(el, {
                all: {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    enableAutoplay: false,
                    draggable: false
                },
                "(max-width: 1024px)": {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                },
                "(max-width: 768px)": {
                    slidesToScroll: 1,
                    slidesToShow: 1,
                }
            })

            if (el.classList.contains('white-buttons')) {
                el.querySelectorAll('.blaze-pagination').forEach(page => {
                    let buttons = page.querySelectorAll('button')
                    if (buttons.length > 0) {
                        var lastchild = buttons[buttons.length-1];
                        lastchild.setAttribute('data-count', lastchild.innerHTML + ' /')
                    }
                })
            }
        })


    },
}

export default {
    can: () => document.querySelector('.blaze-slider'),
    run: fn.init,
}
